var ezdia;
(function (ezdia) {
    var NAME = 'localStorage';
    var TYPE = 'localStorage';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var wrapperId = 'ez-local-storage-review';
    var wrapperConfirmId = 'ez-local-storage-confirm';
    var cusdelete = 'cusdelete';
    var DEFAULT = {
        accountKey: 'account',
        cols: {},
        inputBlock: '[data-row="input"]',
        actionBlock: '[data-row="actionLink"]',
        linkTemplate: 'base-form-field-action-link',
        notification: ezdia.templates.localStorage.notification,
        review: ezdia.templates.localStorage.review,
        inputlistTemplate: 'group-field-list',
        updateRate: 3000
    };
    // PRIVATE FUNCTIONS
    // =========================
    var getEditor = function (id) {
        var ed = null;
        try {
            ed = tinymce.get(id);
            ed.getBody();
        }
        catch (err) {
            ed = null;
        }
        return ed;
    };
    var getMultichoiceVal = function (str) {
        return str ? str.split('##').join(', ') : '';
    };
    var LocalStorage = /** @class */ (function () {
        function LocalStorage(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(LocalStorage.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        LocalStorage.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        LocalStorage.prototype.discard = function (objProps) {
            var accountKey = null;
            var obj = objProps || {};
            if (obj.link) {
                var key = this.accountKey + "." + obj.column.name;
                localStorage.removeItem(key);
                obj.link.remove();
            }
            else {
                if (obj.accountKey) {
                    accountKey = obj.accountKey;
                }
                else {
                    accountKey = this.accountKey;
                }
                var reg_1 = new RegExp(accountKey);
                Object.keys(localStorage).forEach(function (key) {
                    if (reg_1.test(key)) {
                        localStorage.removeItem(key);
                    }
                });
            }
        };
        LocalStorage.prototype.update = function (elem, event) {
            var key = null;
            var oldValue = null;
            var newValue = null;
            var name = null;
            if (elem instanceof jQuery) {
                name = elem.attr('name');
                oldValue = this.formData[name];
                newValue = elem.val();
            }
            else {
                name = $("#" + elem.id).attr('name');
                oldValue = this.formData[name] || '';
                newValue = elem.getContent();
            }
            newValue = newValue || '';
            key = this.accountKey + "." + name;
            if (event && event.type === cusdelete) {
                // eslint-disable-next-line no-param-reassign
                elem = $("#" + name + "_sys_delete").is(':checked');
                var checkbox = elem;
                var timestamp = getCurrentDateTime();
                if (checkbox) {
                    localStorage[this.accountKey] = timestamp;
                    localStorage[key] = JSON.stringify({
                        action: event,
                        timestamp: timestamp
                    });
                }
                else {
                    localStorage.removeItem(key);
                }
            }
            else if (oldValue.trim() !== newValue.trim()) {
                var timestamp = getCurrentDateTime();
                localStorage[this.accountKey] = timestamp;
                localStorage[key] = JSON.stringify({
                    value: newValue,
                    timestamp: timestamp
                });
            }
        };
        LocalStorage.prototype.editor = function (ed) {
            var _this = this;
            var version = tinymce.majorVersion;
            if (this.accountKey) {
                if (version === 3) {
                    tinymce.dom.Event.add(ed.getBody(), 'focus', function () {
                        _this.start(ed);
                    });
                    tinymce.dom.Event.add(ed.getBody(), 'blur', function () {
                        _this.stop(ed);
                    });
                }
                else {
                    ed.on('focus', function () {
                        _this.start(ed);
                    });
                    ed.on('blur', function () {
                        _this.stop(ed);
                    });
                }
            }
        };
        LocalStorage.prototype.destroy = function () {
            this.$elem.removeData("ez." + TYPE);
            this.$elem.off("ez." + TYPE);
        };
        LocalStorage.prototype.init = function (options) {
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.accountKey = this.options.accountKey;
            this.active = false;
            this.formData = {};
            this.localData = {};
            this.storedColModel = [];
            this.render();
        };
        LocalStorage.prototype.render = function (cols) {
            var self = this;
            var inputs = cols || self.options.cols;
            if (typeof inputs === 'string') {
                inputs = ezdia.util.jsonParse(inputs);
            }
            // eslint-disable-next-line consistent-return
            $.each(inputs, function (_i, column) {
                var elem = null;
                var name = column.name;
                var timestamp = false;
                var value = '';
                if (!column.editable) {
                    return true;
                }
                if (column.edittype === 'json') {
                    var config_1 = column.config || {};
                    var json = config_1.fields || config_1 || null;
                    if (json) {
                        self.render(json);
                    }
                    return true;
                }
                elem = self.$elem.find("[name=" + name + "]");
                timestamp = self.hasLocalValue(column);
                if (!elem.length) {
                    return true;
                }
                if (timestamp) {
                    self.buildLink(elem, timestamp, column);
                }
                if (column.edittype === 'html' && elem.length) {
                    value = elem[0].value;
                }
                else {
                    value = elem.val();
                }
                self.formData[name] = value || '';
                self.bindEvents(elem, column);
            });
            if (!$.isEmptyObject(this.localData)) {
                this.notificationDialog();
            }
        };
        LocalStorage.prototype.buildLink = function (elem, timestamp, column) {
            var options = this.options;
            var parents = elem.parents(options.inputBlock);
            var actionBlock = parents.find(options.actionBlock);
            var template = $.ezdia.template.get(options.linkTemplate);
            var name = column.name;
            var link = template({
                name: name,
                localStorage: {
                    id: "ez-local-storage-link-" + name,
                    timestamp: timestamp,
                    type: column.type,
                    label: column.label
                }
            });
            if (actionBlock.length) {
                link = $(link).html();
                actionBlock.append(link);
            }
            else {
                parents.append(link);
            }
        };
        LocalStorage.prototype.bindEvents = function (elem, column) {
            var _this = this;
            var self = this;
            var name = elem.attr('name');
            var attId = elem.attr('id');
            var ed = null;
            var id = $("#ez-local-storage-link-" + name);
            if (id.length) {
                id.on("click.ez" + TYPE, $.proxy(this.review, this, column));
                this.storedColModel.push(column);
            }
            if (column.edittype === 'html') {
                ed = getEditor(attId);
                if (ed) {
                    this.editor(ed);
                }
                else {
                    return;
                }
            }
            if (!elem.is(':visible')) {
                elem.change(".ez" + TYPE, function () {
                    _this.update(elem);
                });
            }
            else {
                elem
                    .focus(".ez" + TYPE, function () {
                    self.start(elem);
                })
                    .on("focusout.ez" + TYPE, function () {
                    self.stop(elem);
                });
            }
            elem.on(cusdelete + ".ez" + TYPE, function (e) {
                self.update(elem, e);
            });
        };
        LocalStorage.prototype.review = function (column, e) {
            var elem = null;
            var name = column.name;
            var type = column.edittype;
            var config = column.config || {};
            var storedObj = this.localData[name];
            var storedVal = storedObj.value.value;
            var action = storedObj.value.action;
            var data = {
                timestamp: storedObj.value.timestamp,
                currentVal: this.formData[name],
                storedVal: null
            };
            if (action && action.type === cusdelete) {
                data.displayVal = 'You deleted this value.';
            }
            else if (type === 'textarea' || type === 'comment') {
                data.storedVal = storedVal;
                data.currentVal = ezdia.util.sanitizer.html(data.currentVal);
                data.displayVal = ezdia.util.sanitizer.html(storedVal);
            }
            else if (type === 'inputlist') {
                var template = $.ezdia.template.get(this.options.inputlistTemplate);
                data.displayVal = template({
                    mode: 'list',
                    editable: false,
                    rows: ezdia.util.jsonParse(storedVal)
                });
                data.storedVal = storedVal;
            }
            else if (type === 'date') {
                data.currentVal = $.ezdia.date.view(config, data.currentVal);
                data.displayVal = $.ezdia.date.view(config, storedVal);
                data.storedVal = storedVal;
            }
            else if (type === 'checkbox') {
                data.currentVal = $.ezdia.checkbox.view({
                    column: column,
                    value: data.currentVal,
                    gridview: true
                });
                data.displayVal = $.ezdia.checkbox.view({
                    column: column,
                    value: storedVal,
                    gridview: true
                });
                data.storedVal = storedVal;
            }
            else if (type === 'multichoice') {
                data.currentVal = getMultichoiceVal(data.currentVal);
                data.displayVal = getMultichoiceVal(storedVal);
                data.storedVal = storedVal;
            }
            else if (type === 'group') {
                data.currentVal = this.getGroupValue(config, data.currentVal);
                data.displayVal = this.getGroupValue(config, storedVal);
                data.storedVal = storedVal;
            }
            else if (type === 'filetype' || type === 'file') {
                data.currentVal = $.ezdia.upload.view({
                    column: column,
                    value: data.currentVal,
                    preview: true
                });
                data.displayVal = $.ezdia.upload.view({
                    column: column,
                    value: storedVal,
                    preview: true
                });
                data.storedVal = storedVal;
            }
            else if (type === 'entityLabel') {
                data.currentVal = $.ezdia.entityLabeling.localStorageView({
                    column: column,
                    value: data.currentVal,
                    preview: true
                });
                data.displayVal = $.ezdia.entityLabeling.localStorageView({
                    column: column,
                    value: storedVal,
                    preview: true
                });
                data.storedVal = storedVal;
            }
            else {
                data.storedVal = storedVal;
                data.displayVal = storedVal;
            }
            if (e) {
                elem = $(e.currentTarget);
                this.openDialog(data, elem, column, action);
            }
            else {
                this.restore(data.storedVal, null, column, action);
            }
        };
        LocalStorage.prototype.restoreAll = function () {
            var self = this;
            $.each(this.storedColModel, function (i, column) {
                self.review(column);
            });
        };
        LocalStorage.prototype.start = function (elem) {
            var self = this;
            if (!self.active) {
                self.active = true;
                self.interval = setInterval(function () {
                    self.update(elem);
                }, self.options.updateRate);
            }
        };
        LocalStorage.prototype.stop = function (elem) {
            var self = this;
            if (self.active) {
                clearInterval(self.interval);
                self.active = false;
                self.update(elem);
            }
        };
        LocalStorage.prototype.hasLocalValue = function (column) {
            var local = false;
            var name = column.name;
            var key = this.accountKey + "." + name;
            var value = localStorage[key];
            if (value) {
                try {
                    value = ezdia.util.jsonParse(value);
                }
                catch (err) {
                    value = null;
                }
                this.localData[name] = {
                    value: value,
                    type: column.edittype,
                    label: column.label
                };
                local = value.timestamp;
            }
            return local;
        };
        LocalStorage.prototype.confirmDelete = function (panel, singleObj) {
            var wrapper = ezdia.util.getWrapper(wrapperConfirmId);
            var self = this;
            wrapper
                .html('Are you sure you want to delete local saved date? <br /> You will not be able to reverse this action.')
                .dialog({
                modal: true,
                title: 'Unsaved changes',
                width: 400,
                height: 200,
                buttons: [
                    {
                        text: 'No, Thank you',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Yes',
                        class: 'btn-default',
                        click: function () {
                            self.discard(singleObj);
                            if (!singleObj) {
                                self.clearLinks();
                            }
                            $(this).dialog('close');
                            panel.dialog('close');
                        }
                    }
                ]
            });
        };
        LocalStorage.prototype.notificationDialog = function () {
            var self = this;
            var arr = [];
            var template = this.options.notification;
            var wrapper = ezdia.util.getWrapper(wrapperId);
            var name;
            $.each(this.localData, function (key, obj) {
                if (!name) {
                    name = key;
                }
                arr.push(obj);
            });
            wrapper.html(template({
                timestamp: localStorage[this.accountKey],
                list: arr
            }));
            wrapper.dialog({
                modal: true,
                title: 'Unsaved changes',
                width: 600,
                height: 350,
                buttons: [
                    {
                        text: 'Discard all',
                        class: 'btn-link',
                        click: function () {
                            self.confirmDelete.call(self, $(this));
                        }
                    },
                    {
                        text: 'Restore all',
                        click: function () {
                            self.restoreAll();
                            self.clearLinks();
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Go to item',
                        click: function () {
                            var elem = self.$elem.find("[name=" + name + "]");
                            var animatedWrapper = $('.animated-wrapper');
                            var topPad = 0;
                            var panelBody = null;
                            elem = elem.parents(self.options.inputBlock);
                            if (animatedWrapper.length) {
                                topPad = +animatedWrapper.css('paddingTop') || 0;
                                topPad = +topPad;
                            }
                            panelBody = elem.closest('.panel-body');
                            if (panelBody.length && !panelBody.is(':visible')) {
                                panelBody
                                    .addClass('in')
                                    .css('height', 'auto')
                                    .prev('.ez-form-fields-grp-heading')
                                    .removeClass('collapsed');
                            }
                            $('html, body').animate({
                                scrollTop: elem.offset().top - topPad
                            }, 500);
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        };
        LocalStorage.prototype.openDialog = function (data, link, column, action) {
            var css = '';
            var self = this;
            var template = this.options.review;
            var wrapper = ezdia.util.getWrapper(wrapperId);
            var widths = 600;
            var heights = 350;
            data.edittype = column.edittype;
            wrapper.html(template(data));
            if (column.edittype === 'html' ||
                column.edittype === 'filetype' ||
                column.edittype === 'file') {
                widths = '100%';
                heights = window.innerHeight;
            }
            wrapper.dialog({
                modal: true,
                title: "Restore/discard unsaved changes - " + column.label,
                width: widths,
                height: heights,
                buttons: [
                    {
                        text: 'Close',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Discard',
                        class: 'btn-default',
                        click: function () {
                            self.confirmDelete.call(self, $(this), {
                                link: link,
                                column: column
                            });
                        }
                    },
                    {
                        text: 'Restore',
                        class: 'btn-primary',
                        click: function () {
                            $(this).dialog('close');
                            self.restore(data.storedVal, link, column, action);
                        }
                    }
                ]
            });
            if (column.edittype === 'html') {
                $('#ez-local-storage-review-date').remove();
                setTimeout(function () {
                    $('#local-save-review-old-frm')
                        .contents()
                        .find('body')
                        .html(css + data.displayVal);
                    $('#local-save-review-new-frm')
                        .contents()
                        .find('body')
                        .html(css + data.currentVal);
                }, 100);
                $('#ez-local-storage-review')
                    .siblings('.ui-dialog-buttonpane')
                    .prepend("<div id=\"ez-local-storage-review-date\" style=\"padding-top: 15px; float: left\"><span class=\"text-muted small\">Last modified on:</span> " + data.timestamp + "</div>");
            }
        };
        LocalStorage.prototype.restore = function (storedVal, link, column, action) {
            var type = column.edittype;
            var name = column.name;
            var elem = $("[name=" + name + "]");
            var id = elem.attr('id');
            var checked = false;
            if (action && action.type === cusdelete) {
                elem = $("#" + name + "_sys_delete");
                checked = elem.is(':checked');
                if (!checked) {
                    elem.trigger('click');
                }
            }
            else {
                switch (type) {
                    case 'slider':
                        elem.bootstrapSlider('setValue', +storedVal);
                        setSliderValue(id, storedVal);
                        break;
                    case 'multichoice':
                        this.setMultichoiceVal(storedVal, elem, id);
                        break;
                    case 'inputlist':
                    case 'groupField':
                        elem.inputList('refresh', storedVal);
                        break;
                    case 'attributes':
                        elem.inputList('refresh', storedVal);
                        break;
                    case 'inputtab':
                        elem.inputTab('refresh', storedVal);
                        break;
                    case 'date':
                        elem = $("#" + (column.id || column.name));
                        elem.val(storedVal).trigger('change');
                        break;
                    case 'checkbox':
                        $.ezdia.checkbox.restore({ column: column, value: storedVal });
                        break;
                    case 'group':
                        this.setGroupValue(elem, column, storedVal);
                        break;
                    case 'combo':
                    case 'tag':
                        $.each(storedVal.split(','), function (index, value) {
                            $.ezdia.tagInput.addValue(elem, value);
                        });
                        break;
                    case 'filetype':
                        $.ezdia.upload.refresh({ name: column.name, value: storedVal });
                        break;
                    case 'segment':
                        $.ezdia.segment.setValue({ name: column.name, value: storedVal });
                        break;
                    case 'inline':
                        $.ezdia.inline.setValue({
                            element: elem,
                            value: storedVal
                        });
                        break;
                    case 'creativebrief':
                        $.ezdia.creativeBrief.setValue({
                            element: elem,
                            value: storedVal
                        });
                        break;
                    case 'singlechoice':
                        elem.val(storedVal).trigger('change');
                        if (elem.data('chosen')) {
                            elem.trigger('chosen:updated');
                        }
                        break;
                    case 'entityLabel':
                        $.ezdia.entityLabeling.setValueAndUpdate({
                            element: elem,
                            value: storedVal
                        });
                        break;
                    default:
                        elem.val(storedVal).trigger('change');
                        break;
                }
            }
            if (link) {
                link.focusout();
                link.remove();
            }
        };
        LocalStorage.prototype.setMultichoiceVal = function (storedVal, elem, id) {
            var str = storedVal.replace(/##/g, '@@##');
            var arr = str.split('@@');
            elem.val(storedVal);
            $("#" + id + "-multichoice").val(arr).multiSelect('refresh');
        };
        LocalStorage.prototype.clearLinks = function () {
            $('a[id*=ez-local-storage-link-]').each(function each() {
                var elem = $(this);
                var id = elem.closest('[data-row="actionLink"]').attr('id');
                var parent = null;
                elem.remove();
                parent = $("#" + id);
                if (!parent.html().trim()) {
                    parent.hide();
                }
            });
        };
        LocalStorage.prototype.setGroupValue = function (elem, column, value) {
            var config = column.config || {};
            var label = this.getGroupValue(config, value);
            elem.val(value);
            $("#" + (column.id || column.name)).typeahead('val', label);
        };
        LocalStorage.prototype.getGroupValue = function (config, value) {
            var label = value;
            if (config.options) {
                label = config.options[value] || value;
            }
            return label;
        };
        return LocalStorage;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        editor: LocalStorage.prototype.editor,
        update: LocalStorage.prototype.update,
        discard: LocalStorage.prototype.discard,
        destroy: LocalStorage.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _a = 1; _a < arguments.length; _a++) {
            args[_a - 1] = arguments[_a];
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                return $(this);
            }
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof LocalStorage) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new LocalStorage(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = LocalStorage;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
